import React, { useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getTopMeetingParticipantsAsync,
  makeTopMeetingParticipants,
} from "../reducer";
import ChartWithDetailedTooltip from "../ChartWithDetailedTooltip";
import {
  getTopMeetingParticipantsDetailedInformation,
  showDetails,
} from "../consts";
import { makeProfile } from "@client.pages/Login/reducer";
import { filterPropTypes } from "../utils";
import useModal from "@client.hooks/useModal";
import { CHART_CLASS } from "./CustomXAxisTick";
import TopMeetingParticipantsChart from "./TopMeetingParticipantsChart";
import "./TopMeetingParticipants.scss";
import { useNavigate } from "react-router-dom";

const TopMeetingParticipants = ({ filter, onError }) => {
  const navigate = useNavigate();
  const topMeetingParticipants = useSelector(makeTopMeetingParticipants);
  const profile = useSelector(makeProfile);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { showModal } = useModal();

  if (topMeetingParticipants.error) {
    onError(topMeetingParticipants.error);
  }

  useEffect(() => {
    dispatch(
      getTopMeetingParticipantsAsync({
        ...filter,
        isCostIndexPresentation: profile.isCostIndexPresentation,
      })
    );
  }, [dispatch, filter, profile]);

  const getDetailedInformation = useCallback(
    (payload) => {
      return getTopMeetingParticipantsDetailedInformation(payload, t, filter);
    },
    [t, filter]
  );

  const showDetailsModal = useCallback(
    (payload) => {
      showDetails(
        payload,
        showModal,
        getDetailedInformation,
        t,
        filter,
        navigate
      );
    },
    [showModal, getDetailedInformation, t, filter, navigate]
  );

  return (
    <ChartWithDetailedTooltip
      title={t("components.Charts.topMeetingParticipants")}
      className={CHART_CLASS}
      dataSource={topMeetingParticipants}
      onError={onError}
      isHorizontal={false}
      renderChartContent={(
        handleBarMouseEnter,
        handleBarMouseMove,
        handleBarMouseLeave
      ) => {
        return (
          <TopMeetingParticipantsChart
            data={topMeetingParticipants.data}
            showDetailsModal={showDetailsModal}
            handleBarMouseEnter={handleBarMouseEnter}
            handleBarMouseMove={handleBarMouseMove}
            handleBarMouseLeave={handleBarMouseLeave}
          />
        );
      }}
    />
  );
};

TopMeetingParticipants.propTypes = {
  onError: PropTypes.func.isRequired,
  filter: filterPropTypes,
};

export default TopMeetingParticipants;
